/* eslint-disable */
import Grid from '@material-ui/core/Grid';
import LinearProgress from '@material-ui/core/LinearProgress';
import { withStyles } from '@material-ui/core/styles';
import round from 'lodash/round';
import React from 'react';
import { compose } from 'redux';
import { ORDER_STATUS_CANCELLED } from '../../Constants/Order/Order.constants';
import toDisplayUnit from '../../Support/Converters/ToDisplayUnit/ConvertersToDisplayUnit.support';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import I18n from '../I18n/I18n.component';
import OrderQuantityPropTypes from './OrderQuantity.component.props';
import orderQuantityStyles from './OrderQuantity.component.styles';

/**
 * OrderQuantityComponent
 * @export
 * @class OrderQuantityComponent
 * @extends {React.Component<OrderQuantityComponentComposedProps, OrderQuantityComponentState>}
 */
export class OrderQuantityComponent extends React.Component {
  /**
   * The `props` to seed when any specific prop receives an `undefined` value. NOT a `null` value
   * @static
   * @type {Partial<OrderQuantityComponentProps>}
   * @memberof OrderQuantityComponent
   */
  static defaultProps = {};

  /**
   * The name of the Component to display when debugging
   * @static
   * @type {`OrderQuantity`}
   * @memberof OrderQuantityComponent
   */
  static displayName = `OrderQuantity`;

  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof OrderQuantityComponent
   */
  static propTypes = OrderQuantityPropTypes;

  /**
   * Data specific to the `<OrderQuantityComponent />` instance
   * @type {OrderQuantityComponentState}
   * @memberof OrderQuantityComponent
   */
  state = {};

  /**
   * Percent to represent progress for the order
   * @param {string} dispatchedAmount The dispatched amount for the order
   * @param {string} orderedAmount The ordered amount for the order
   * @returns {number} The percent to represent progress for the order
   * @memberof OrderQuantityComponent
   */
  getQuantityPercent = (dispatchedAmount, orderedAmount) => {
    return (parseFloat(dispatchedAmount) / parseFloat(orderedAmount)) * 100;
  };

  /**
   * Round off the number
   * @param {string} amount The amount
   * @param {number} precision The precision
   * @returns {number} The rounded off number
   * @memberof OrderQuantityComponent
   */
  round = (amount, precision = 1) => {
    return round(amount, precision);
  };

  /**
   * Render the component
   * @returns {React.Component} The rendered `<OrderQuantityComponent />`
   * @memberof OrderQuantityComponent
   */
  render() {
    const { classes, quantity, status } = this.props;
    if (quantity == null) {
      return null;
    }
    const isCancelled = status === ORDER_STATUS_CANCELLED;
    const { dispatchedAmount, orderedAmount, unitOfMeasure } = quantity;
    const unit = toDisplayUnit(unitOfMeasure);
    const quantityPercent = isCancelled ? 0 : this.getQuantityPercent(dispatchedAmount, orderedAmount);
    const quantityRemaining = this.round(orderedAmount - dispatchedAmount);
    return (
      <div className={classes.quantityContainer}>
        <I18n variant="caption">OrderService.QuantityLabel</I18n>
        <LinearProgress classes={{ root: classes.progressBar }} color="secondary" value={quantityPercent} variant="determinate" />
        <Grid classes={{ container: classes.progressBarText }} container justify="space-between">
          <I18n data={{ quantity: this.round(dispatchedAmount), unit }} gutterBottom variant="body1">
            OrderService.QuantityDispatched
          </I18n>
          {!isCancelled && (
            <I18n data={{ quantity: quantityRemaining, unit }} gutterBottom variant="body1">
              OrderService.QuantityRemaining
            </I18n>
          )}
        </Grid>
      </div>
    );
  }
}

/** @type {React.ComponentClass<OrderQuantityComponentProps>} */
const OrderQuantity = compose(withStyles(themeCreateInjectableStyles(orderQuantityStyles), { withTheme: true }))(OrderQuantityComponent);

export default OrderQuantity;
